// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

const myCustomTheme = {
  dark: false,
  colors: {
    primary: "#2E4392",
    loginPageFieldsBG: "#E9F0FD",
    blueColorVariant1: "#758AF8",
    blueColorVariant2: "#666CF7",
    blueColorVariant3: "#538CFF",
    blueColorVariant4: "#6699FF",
    blueColorVariant5: "#4D86F9",
    blueColorVariant6: "#588DF8",
    blueColorVariant7: "#8489f8",
    blueColorVariant8: "#3679FF",
    blueColorVariant9: "#2E4392",
    blueColorVariant10: "#a0add8",

    whiteColorvariant1: "#ffffff",

    greenColorVariant1: "#009900",
  },
};

export default createVuetify({
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme,
    },
  },
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
});
